export default "__VITE_ASSET__CN24ibed__"